import {
  FormStyle,
  getLocaleDayNames,
  NgFor,
  NgIf,
  TranslationWidth,
} from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Fitter, FitterOpeningPeriod } from '@sc/data-access-models';
import { TranslatorService } from '@sc/data-access-translation';
import { FitterInfosBoxComponent } from '@sc/ui-components';

@Component({
  selector: 'sc-mobile-fitter-openings-page',
  styleUrls: ['./mobile-fitter-openings-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [FitterInfosBoxComponent, NgFor, NgIf, TranslateModule],
  template: `
    <h2 id="fitter-opennings-page-title" class="page-title sc-design-title-h2">
      {{ 'FitterOpeningHours.openingHours' | translate }}
    </h2>

    <sc-fitter-infos-box
      [fitter]="fitter"
      [itineraryDistanceInMeters]="itineraryDistanceInMeters"
      [itineraryDurationInSeconds]="itineraryDurationInSeconds"
    ></sc-fitter-infos-box>

    <div class="planing">
      <div class="days-container">
        <div class="day" *ngFor="let dayKey of [1, 2, 3, 4, 5, 6, 0]">
          <div class="day-name sc-design-text-3-bold">{{ days[dayKey] }}</div>
          <div class="hours">
            <div
              class="time sc-design-text-3"
              *ngFor="let period of groupOpeningPeriodsByDay().get(dayKey)"
            >
              {{
                formatGoogleTime(period.open.time) +
                  ' - ' +
                  formatGoogleTime(period.close.time)
              }}
              &nbsp;&nbsp;
            </div>
            <div
              class="time sc-design-text-3"
              *ngIf="!groupOpeningPeriodsByDay().get(dayKey)"
            >
              {{ 'FitterOpeningHours.closed' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class MobileFitterOpeningsPageComponent {
  @Input() fitter: Fitter;
  @Input() itineraryDistanceInMeters = 0;
  @Input() itineraryDurationInSeconds = 0;

  constructor(private readonly translator: TranslatorService) {
    this.translator.getCurrentLang().subscribe((newFormattedLang) => {
      this.days = getLocaleDayNames(
        newFormattedLang,
        FormStyle.Standalone,
        TranslationWidth.Wide
      );
    });
  }

  days: readonly string[];

  groupOpeningPeriodsByDay(): Map<number, FitterOpeningPeriod[]> {
    const result = new Map<number, FitterOpeningPeriod[]>();
    for (const period of this.fitter?.openingHours?.center || []) {
      const day = period.open.day;
      if (result.has(day)) {
        result.get(day).push(period);
      } else {
        result.set(day, [period]);
      }
    }
    return result;
  }

  formatGoogleTime(time: string): string {
    return time.substring(0, 2) + ':' + time.substring(2);
  }
}
